import { CurrencyCode } from "../../constants/enums";
import { TenantCreatedEvent } from "../events/TenantCreatedEvent";
import { TenantDeletedEvent } from "../events/TenantDeletedEvent";
import { TenantUpdatedEvent } from "../events/TenantUpdatedEvent";
import { MspBillingInfoEntity } from "./MspBillingInfo";
import { MspTenantSettingsEntity } from "./MspTenantSettings";

export const TenantStatus = {
  ACTIVE: "ACTIVE",
  ACTIVE_POV: "ACTIVE_POV",
  INACTIVE_DATA_DELETED: "INACTIVE_DATA_DELETED",
  INACTIVE: "INACTIVE",
} as const;

type TenantEvent = TenantCreatedEvent | TenantUpdatedEvent | TenantDeletedEvent;

// TODO: Handle other TenantEvents
type TenantEventData = Omit<TenantUpdatedEvent, "type">;

export type TenantEventEntity = {
  id: string;
  invokerID: string;
  tenantID: string;
  createdAt: string;
  data: TenantEventData;
  type: TenantEvent["type"];
};

export type TenantStatus = (typeof TenantStatus)[keyof typeof TenantStatus];

export const TenantType = {
  DIRECT_CUSTOMER: "DIRECT_CUSTOMER",
  MSP_CUSTOMER: "MSP_CUSTOMER",
  MSP_PARENT: "MSP_PARENT",
} as const;

export type TenantType = (typeof TenantType)[keyof typeof TenantType];

export type FiscalCalendar = {
  endDate: string;
  periods: { [key: string]: string };
};

export type NotificationPreferences = {
  notifyAlerts: boolean;
  notifyBudgets: boolean;
  notifyRecommendations: boolean;
  notifyReportsDaily: boolean;
  notifyReportsMonthly: boolean;
  notifyReportsWeekly: boolean;
};

type TenantProfile = {
  anomaly: {
    lookbackPeriodSeconds: number;
    standardDeviations: number;
    threshold: number;
  } | null;
  bigQueryAnomaly: { minEstimateUSD: number } | null;
  kubernetesRecommendation: {
    nodepoolMinCostWastedPerHour: number | null;
    workloadMinCostWastedPerHour: number | null;
  } | null;
  recommendation: {
    absoluteIncreasedUSDThreshold: number | null;
    relativeIncreasedUSDThreshold: number | null;
  } | null;
};

export type TenantEntity = {
  id: string;
  fsDocID: string;
  parentTenantID: string | null;
  createdAt: string;
  createdByID: string;
  clientCertificatePEM: string;
  dataDatasetID: string;
  dataLocation: string;
  dataProjectID: string;
  fiscalCalendar: FiscalCalendar | null;
  emailDomain: string;
  isInternal?: boolean;
  mspSettings?: MspTenantSettingsEntity;
  mspBillingInfo?: MspBillingInfoEntity;
  name: string;
  newUserNotificationSettings: NotificationPreferences;
  preferredCurrencyCode: CurrencyCode;
  profile: TenantProfile | null;
  publicKeyPEM: string;
  serviceAccountEmail: string;
  serviceAccountUID: string;
  status: TenantStatus;
  type: TenantType;
  updatedAt: string | null;
  updatedByID: string | null;
};
